import { useWizard } from "components/elements/Wizard/useWizard";
import { useFormikContext } from "formik";
import { SpeckleImportModel } from "../types/SpeckleImportModel";
import SpeckleAccountsListStepVariant from "./SpeckleImportAccountStepVariants/SpeckleAccountsListStepVariant";
import SpeckleAccountAddStepVariant from "./SpeckleImportAccountStepVariants/SpeckleAccountAddStepVariant";
import SpeckleAccountValidationStepVariant from "./SpeckleImportAccountStepVariants/SpeckleAccountValidationStepVariant";
import { useState } from "react";

export default function SpeckleImportAccountStep() {
  const stepVariantAddAccount = "add-account";
  const stepVariantAccountValidate = "account-validate";
  const { isSubmitting, setValues, submitForm } =
    useFormikContext<SpeckleImportModel>();
  const { stepVariant } = useWizard();
  const [connectedAccountId, setConnectedAccountId] = useState<
    string | undefined
  >(undefined);

  async function onSelectAccount(value: string) {
    // ? Only set the value, don't submit the form as we need to validate the account first
    setConnectedAccountId(value);
  }

  async function onValidationSuccess() {
    setValues(
      (values) => ({
        ...values,
        connectedAccountId: connectedAccountId,
      }),
      false,
    );
    // ? Submit the form after the account has been validated
    await new Promise((res) => setTimeout(res, 0)); //hack: cannot submit immediately after setting values
    submitForm();
  }

  return (
    <div>
      {stepVariant === stepVariantAddAccount ? (
        <SpeckleAccountAddStepVariant />
      ) : stepVariant === stepVariantAccountValidate ? (
        <SpeckleAccountValidationStepVariant
          onValidationSuccess={onValidationSuccess}
          connectedAccountId={connectedAccountId}
        />
      ) : (
        <SpeckleAccountsListStepVariant
          isSubmitting={isSubmitting}
          onSelect={onSelectAccount}
        />
      )}
    </div>
  );
}
